var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('h6',[_vm._v("Success!")])])}
var staticRenderFns = []

export { render, staticRenderFns }